export default {
    footer: state => state.footer,
    isLogin: state => !!state.token,
    showlogin: state => state.showlogin,
    notice: state => state.notice,
}